<template>
  <div class="message-content">
    <Card
      title="请选择消息类型"
      :show-delete="showDelete"
      @deleteCard="deleteCard"
    >
      <div slot="cardAction">
        <el-radio-group v-model="cardtype">
          <el-radio label="image">
图片
</el-radio>
          <el-radio label="link">
链接
</el-radio>
          <el-radio label="miniprogram">
小程序 （客户关系绑定必要选项）
</el-radio>
        </el-radio-group>
      </div>

      <div
        slot="content"
        class="message-item"
      >
        <div class="content">
          <!-- 图片 -->
          <div v-if="content.msgtype === 'image'">
            <SpOnlyPicSelect
              :image-url="imageUrl"
              @selectImage="selectImageData"
            />
          </div>

          <!-- 链接 -->
          <div v-if="content.msgtype === 'link'">
            <div class="link-list">
              <span>链接地址：</span>
              <el-input
                v-model="content.link.url"
                placeholder="请输入https或http开头的完整链接"
                size="small"
              >
                <template slot="append">
                  <el-button
                    type="text"
                    @click="autoLink"
                  >
                    <span class="auto-link">自动生成链接信息</span>
                  </el-button>
                </template>
              </el-input>
            </div>
            <div class="link-list">
              <span>链接标题：</span>
              <el-input
                v-model="content.link.title"
                placeholder="请输入链接标题"
                size="small"
              />
            </div>
            <div class="link-list">
              <span>链接摘要：</span>
              <el-input
                v-model="content.link.desc"
                placeholder="请输入链接摘要"
                size="small"
              />
            </div>
            <div class="link-list">
              <span>链接封面：</span>
              <div>
                <SpOnlyPicSelect
                  :image-url="imageUrl"
                  @selectImage="selectImageData"
                />
              </div>
            </div>
          </div>

          <!-- 小程序 -->
          <div v-if="content.msgtype === 'miniprogram'">
            <div class="link-list">
              <span>小程序标题：</span>
              <el-input
                v-model="content.miniprogram.title"
                placeholder="请输入小程序标题"
                size="small"
              />
            </div>
            <div class="link-list">
              <span>小程序路径：</span>
              <el-input
                v-model="content.miniprogram.page"
                placeholder="请输入小程序路径"
                size="small"
              />
              <el-select
                v-model="value"
                placeholder="云店小程序页面"
                class="ml10"
                @change="handleChange"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
            <div class="link-list">
              <span />
              <div>
                <span>指定自定义活动页，指定优惠券，指定商品请至销售中心对应页面复制链接 </span>
              </div>
            </div>
            <div class="link-list">
              <span>小程序封面：</span>
              <div>
                <SpOnlyPicSelect
                  :image-url="imageUrl"
                  @selectImage="selectImageData"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import Card from '../comps/card.vue'

export default {
  name: 'MessageContent',
  components: { Card },
  props: {
    content: {
      type: Object,
      default: () => {
        return {}
      }
    },
    showDelete: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      programVisible: false,
      imageVisible: false,
      cardtype: this.content.msgtype,
      options: [
        {
          value: '选项1',
          label: '首页'
        },
        {
          value: '选项2',
          label: '商品分类'
        },
        {
          value: '选项3',
          label: '优惠券列表'
        },
        {
          value: '选项4',
          label: '种草列表'
        },
        {
          value: '选项5',
          label: '会员中心'
        },
        {
          value: '选项6',
          label: '商品列表'
        }
      ],
      value: ''
    }
  },
  computed: {
    imageUrl () {
      let pic = ''
      let msg_type = this.content.msgtype
      if (msg_type === 'image') {
        pic = this.content.image.pic_url
      } else if (msg_type === 'link') {
        pic = this.content.link.picurl
      } else if (msg_type === 'miniprogram') {
        pic = this.content.miniprogram.img_url
      }
      return pic
    }
  },
  watch: {
    cardtype (newValue) {
      this.$emit('updateCardType', {
        type: newValue
      })
    }
  },
  created () {
    if (this.content.miniprogram.page === 'pages/index') {
      this.value = '选项1'
    }
    if (this.content.miniprogram.page === 'pages/category/index') {
      this.value = '选项2'
    }
    if (this.content.miniprogram.page === 'pages/coupon-home/index') {
      this.value = '选项3'
    }
    if (this.content.miniprogram.page === 'pages/recommend/list') {
      this.value = '选项4'
    }
    if (this.content.miniprogram.page === 'pages/member/index') {
      this.value = '选项5'
    }
    if (this.content.miniprogram.page === 'pages/item/list') {
      this.value = '选项6'
    }
  },
  methods: {
    selectImageData (selectdata) {
      let msg_type = this.content.msgtype
      if (msg_type === 'image') {
        this.content.image.pic_url = selectdata
      } else if (msg_type === 'link') {
        this.content.link.picurl = selectdata
      } else if (msg_type === 'miniprogram') {
        this.content.miniprogram.img_url = selectdata
      }
    },
    deleteCard () {
      this.$emit('deleteCard')
    },

    // 自动获取连接信息
    async autoLink () {
      const { url } = this.content.link
      const data = await this.$api.component.getLinkTDK({ url })
      if (data) {
        const { title, picurl, desc } = data
        this.content.link = {
          url,
          title,
          picurl,
          desc
        }
      }
    },
    handleChange () {
      console.log(this.value)
      if (this.value === '选项1') {
        this.content.miniprogram.title = '首页'
        this.content.miniprogram.page = 'pages/index'
      }
      if (this.value === '选项2') {
        this.content.miniprogram.title = '商品分类'
        this.content.miniprogram.page = 'pages/category/index'
      }
      if (this.value === '选项3') {
        this.content.miniprogram.title = '优惠券列表'
        this.content.miniprogram.page = 'others/pages/home/coupon-home'
      }
      if (this.value === '选项4') {
        this.content.miniprogram.title = '种草列表'
        this.content.miniprogram.page = 'pages/recommend/list'
      }
      if (this.value === '选项5') {
        this.content.miniprogram.title = '会员中心'
        this.content.miniprogram.page = 'pages/member/index'
      }
      if (this.value === '选项6') {
        this.content.miniprogram.title = '商品列表'
        this.content.miniprogram.page = 'pages/item/list'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.message-item {
  padding: 20px 12px;
  width: 100%;
}
.content {
  display: flex;
  align-items: center;
  > div {
    width: 100%;
  }
  .link-list {
    width: 100%;
    span {
      width: 95px;
      color: #666;
    }
    .auto-link {
      color: #409eff;
      font-size: 12px;
      padding: 0 4px;
    }
    > div {
      flex: 1;
    }
    margin-bottom: 6px;
    display: flex;
    .ml10 {
      margin-left: 10px;
    }
  }
}
</style>
